import * as api from '../api/tirz';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const FETCH_TIRZS = createRequestTypes('TIRZ/FETCH_TIRZS');

export const fetchTIRZS = makeApiActionCreatorV3(
  api.fetchTIRZS,
  FETCH_TIRZS[START],
  FETCH_TIRZS[SUCCESS],
  FETCH_TIRZS[ERROR],
);

export const FETCH_TIRZ = createRequestTypes('TIRZ/FETCH_TIRZ');

export const fetchTIRZ = makeApiActionCreatorV3(
  api.fetchTIRZ,
  FETCH_TIRZ[START],
  FETCH_TIRZ[SUCCESS],
  FETCH_TIRZ[ERROR],
);

export const CREATE_TIRZ = createRequestTypes('TIRZ/CREATE_TIRZ');

export const createTIRZ = makeApiActionCreatorV3(
  api.createTIRZ,
  CREATE_TIRZ[START],
  CREATE_TIRZ[SUCCESS],
  CREATE_TIRZ[ERROR],
);

export const UPDATE_TIRZ = createRequestTypes('TIRZ/UPDATE_TIRZ');

export const updateTIRZ = makeApiActionCreatorV3(
  api.updateTIRZ,
  UPDATE_TIRZ[START],
  UPDATE_TIRZ[SUCCESS],
  UPDATE_TIRZ[ERROR],
);

export const FETCH_TIRZ_TAXING_UNITS = createRequestTypes(
  'TIRZ/FETCH_TIRZ_TAXING_UNITS',
);

export const fetchTIRZTaxingUnits = makeApiActionCreatorV3(
  api.fetchTIRZTaxingUnits,
  FETCH_TIRZ_TAXING_UNITS[START],
  FETCH_TIRZ_TAXING_UNITS[SUCCESS],
  FETCH_TIRZ_TAXING_UNITS[ERROR],
);

export const ADD_TIRZ_TAXING_UNIT = createRequestTypes(
  'TIRZ/ADD_TIRZ_TAXING_UNIT',
);

export const addTIRZTaxingUnit = makeApiActionCreatorV3(
  api.addTIRZTaxingUnit,
  ADD_TIRZ_TAXING_UNIT[START],
  ADD_TIRZ_TAXING_UNIT[SUCCESS],
  ADD_TIRZ_TAXING_UNIT[ERROR],
);

export const DELETE_TIRZ_TAXING_UNIT = createRequestTypes(
  'TIRZ/DELETE_TIRZ_TAXING_UNIT',
);

export const deleteTIRZTaxingUnit = makeApiActionCreatorV3(
  api.deleteTIRZTaxingUnit,
  DELETE_TIRZ_TAXING_UNIT[START],
  DELETE_TIRZ_TAXING_UNIT[SUCCESS],
  DELETE_TIRZ_TAXING_UNIT[ERROR],
);

export const INSERT_TIRZ_FILE = createRequestTypes('TIRZ/INSERT_TIRZ_FILE');

export const insertTIRZFile = makeApiActionCreatorV3(
  api.insertTIRZFile,
  INSERT_TIRZ_FILE[START],
  INSERT_TIRZ_FILE[SUCCESS],
  INSERT_TIRZ_FILE[ERROR],
);

export const DOWNLOAD_TIRZ_FILE = createRequestTypes('TIRZ/DOWNLOAD_TIRZ_FILE');

export const downloadTIRZFile = makeApiActionCreatorV3(
  api.downloadTIRZFile,
  DOWNLOAD_TIRZ_FILE[START],
  DOWNLOAD_TIRZ_FILE[SUCCESS],
  DOWNLOAD_TIRZ_FILE[ERROR],
);
